import { baseSplitApi as api } from "./baseApi";

const injectedRtkApi = api.injectEndpoints({
  endpoints: (build) => ({
    getBackOfficeListProducts: build.query<
      GetBackOfficeListProductsApiResponse,
      GetBackOfficeListProductsApiArg
    >({
      query: (queryArg) => ({
        url: `/v1/bo/products`,
        params: {
          page: queryArg.page,
          size: queryArg.size,
          keyword: queryArg.keyword,
          sort: queryArg.sort,
        },
      }),
    }),
  }),
  overrideExisting: false,
});
export { injectedRtkApi as bigsystherApi };
export type GetBackOfficeListProductsApiResponse =
  /** status 200 OK */ BackOfficeProductPage;
export type GetBackOfficeListProductsApiArg = {
  /** page */
  page?: number;
  /** size */
  size?: number;
  /** keyword to search */
  keyword?: string;
  /** Format is sort=distance:desc,name:asc. Supported keys: createdAt, updatedAt, vendorProductID */
  sort?: string[];
};
export type EntityProductType = "pt-subscription" | "pt-credits";
export type EntityProduct = {
  createdAt?: string;
  description?: string;
  /** Product id of Google Play Store */
  googleVendorProductID?: string;
  id?: string;
  priceLevel?: number;
  /** The product can be a subscription or a one-time credit purchase. */
  type?: EntityProductType;
  updatedAt?: string;
  /** Product id of Apple App Store */
  vendorProductID?: string;
};
export type BackOfficeProductPage = {
  count?: number;
  items?: EntityProduct[];
  last?: boolean;
  page?: number;
  size?: number;
};
export type ValidationError = {
  field?: string;
  message?: string;
};
export type ErrorResponse400 = {
  code?: number;
  data?: ValidationError[];
  message?: string;
};
export type ErrorResponse404 = {
  code?: number;
  data?: {
    [key: string]: string;
  }[];
  message?: string;
};
export const { useGetBackOfficeListProductsQuery } = injectedRtkApi;
